import * as React from "react";
import { updateEditableFields } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { CANCEL_BUTTON_TEXT_FIELD, DATA_GRID_TABLE, SAVE_BUTTON_TEXT_FIELD, USAGE_DESCRIPTION_EDITABLE_VIEW, USAGE_ROWS_SECTION_KEY } from "../../../Consts";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import TextDataInput, { SizedTextDataInput } from "../../textDataInput/TextDataInput";
import { SizedDropdownDataInput } from "../../dropdownDataInput/DropdownDataInput";
import IconTextButton from "../../iconTextButton/IconTextButton";
import { IComponentView } from "../../../../redux/types/ComponentView";

import {
  deepClone,
  createNewView,
  getUniqueViewName,
  getUniqueViewNameFromRename,
  DEFAULT_VIEW_NAME,
  mergeFieldsWithSeededFields,
} from "./utils/usageResultsFieldUtils";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { Table } from "antd";
import { ToggleButtonDataInput } from "../../toggleInput/ToggleInput";
import { ColumnsType } from "antd/es/table";
import CheckboxDataInput from "../../checkboxDataInput/CheckboxDataInput";
import { AddCircle20Regular, Delete20Regular, LockClosed20Regular } from "@fluentui/react-icons";
export interface IFieldSettingViewModalProps {
  tableContents: any;
  componentViewData: any;
  componentInstance: string;
  dataGridViewData: IRepertoireComponentDataItem;
  updateEditableFields: typeof updateEditableFields;
  onClickSave: () => void;
  onClickCancel: () => void;
  editableFieldsKey?: string;
  componentViews: IComponentView[];
  activeComponentView?: IComponentView;
  setActiveComponentView?: (componentView: IComponentView) => void;
  updateComponentViews: (componentViews: IComponentView[]) => void;
  getComponentViews?: (componentName: string, componentInstance: string) => void;
  componentViewPreference?: IComponentViewsPreference;
  setIsFormDirty: (isDirty: boolean) => void;
}

const SELECT_VIEW_TO_CONFIGURE = "SelectViewToConfigure";
const RENAME_SELECTED_VIEW = "RenameSelectedView";
interface optionType {
  code: string;
  description: string;
  extraFields?: object;
}

const UsageMaintenanceDetailTableFieldSettingView: React.FC<IFieldSettingViewModalProps> = ({
  getComponentViews,
  tableContents,
  componentViewData,
  componentInstance,
  dataGridViewData,
  updateEditableFields,
  onClickSave,
  onClickCancel,
  editableFieldsKey,
  componentViews,
  updateComponentViews,
  activeComponentView,
  setActiveComponentView,
  componentViewPreference,
  setIsFormDirty,
}) => {
  const [loaded, setLoaded] = React.useState(false);
  const [viewData, setViewData] = React.useState({});
  const [localComponentViewsData, setComponentViewsData] = React.useState<IComponentView[]>([]);
  const [viewsOptions, setViewsOptions] = React.useState<optionType[]>([]);
  const [activeView, setActiveView] = React.useState<string | null>(componentViewPreference?.usageMaintenanceView ? componentViewPreference?.usageMaintenanceView : DEFAULT_VIEW_NAME);
  const [tableContent, setTableContents] = React.useState<IRepertoireField[]>([]);
  const [pendingViewName, setPendingViewName] = React.useState<string>(activeView || '');

const initializeViewData = () => {
  if (componentViewData?.fields) {
    const newViewData = componentViewData.fields.reduce((acc, item) => {
      acc[item.name] = item.data;
      return acc;
    }, {} as Record<string, any>);
    if (componentViewPreference?.usageMaintenanceView ) {
      setActiveView(componentViewPreference.usageMaintenanceView);
    setPendingViewName(componentViewPreference.usageMaintenanceView);
    }
    setViewData(newViewData);
    setLoaded(true);
  }
}

  React.useEffect(() => {
    let newViewData: { [key: string]: IRepertoireField } = {}; ``
    if (!loaded) {
      initializeViewData();
    }
  }, [tableContents])


  React.useEffect(() => {
    if (activeComponentView) {
      setActiveView(activeComponentView.viewName);
      setPendingViewName(activeComponentView.viewName);
    }
    createComponentsViews();
  }, [componentViews, activeComponentView]);

  React.useEffect(() => {
  if (!activeView) return;

  const currentView = localComponentViewsData.find(
    v => v.viewName === activeView && !v.isDeleted
  );

  if (currentView) {
    setTableContents(currentView.fields);
  }
}, [localComponentViewsData, activeView]);

  const getViewsOptions = (views: IComponentView[]) => {
    const filteredAndSortedViews = views
      .filter(view =>
        view.componentInstance === USAGE_ROWS_SECTION_KEY &&
        view.componentName === DATA_GRID_TABLE &&
        view.isDeleted !== true
      )
      .sort((a, b) => a.viewName.localeCompare(b.viewName));

    const options: optionType[] = filteredAndSortedViews.map(view => ({
      code: view.viewName,
      description: view.viewName,
    }));

    setViewsOptions(options);
  };

  const handleViewNameDataChange = (value: string | boolean | number, fieldName: IRepertoireStateKeys) => {
    setIsFormDirty(true);
    if (typeof value === 'string') {
      if (value.trim() === '') {
        value = getUniqueViewName(localComponentViewsData, value);
      }
      setPendingViewName(value);
    }
  };


  const createComponentsViews = () => {
    const defaultEmptyView: IComponentView = createNewView(DEFAULT_VIEW_NAME, DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY, tableContents);
    const newEmptyView: IComponentView = createNewView(getUniqueViewName(localComponentViewsData), DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY, tableContents);
    const defaultEmptyViews = [defaultEmptyView, newEmptyView];

    if (!componentViews?.length) {
      getViewsOptions(defaultEmptyViews);
      setComponentViewsData(deepClone(defaultEmptyViews));
      setTableContents(defaultEmptyViews.find(item => item.viewName === DEFAULT_VIEW_NAME)?.fields || []);
    } else {

            const normalizedViews = componentViews.map(view => ({
                    ...view,
                    fields: mergeFieldsWithSeededFields(
                        view.fields || [],
                        tableContents
                    ),
                }));

      getViewsOptions(normalizedViews);
      setComponentViewsData(deepClone(normalizedViews));
      setTableContents(normalizedViews.find(item => item.viewName === activeView)?.fields || []);
    }
  }

  const changeData = (value: any[], name: IRepertoireStateKeys) => {
    updateEditableFields(value, editableFieldsKey);
  }

  const handleSaveClick = () => {
    setIsFormDirty(false);
    updateComponentViews(localComponentViewsData);
    onClickSave();
  }

  const renderActionButtons = () => {
    return (
      <div >
        <div className="form-group col-lg-3 col-lg-push-6 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-6 col-xs-push-0">
          <button className="button btn-defaultSecondary" onClick={() => onClickCancel()}>
            {viewData[CANCEL_BUTTON_TEXT_FIELD]}
          </button>
        </div>

        <div className="form-group col-lg-3 col-lg-push-6 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-6 col-xs-push-0">
          <button className="button btn-defaultPrimary" onClick={handleSaveClick}>
            {viewData[SAVE_BUTTON_TEXT_FIELD]}
          </button>
        </div>
      </div>
    )
  }

  const handleViewDropdownDataChange = (
    value: string | string[] | boolean,
    fieldName: IRepertoireStateKeys,
  ) => {
   const mergedFields = mergeFieldsWithSeededFields(
            localComponentViewsData.find(item => item.viewName === value)?.fields || [],
            tableContents
        );

    setIsFormDirty(true);
    setActiveView(value as string);
    setPendingViewName(value as string);
    setTableContents(mergedFields);

  }

  const handleChangeData = (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => {
    setIsFormDirty(true);
    setComponentViewsData(prevState => {
      const updatedViews = prevState.map(item => {
        if (item.viewName === activeView) {
          return { ...item, fields: value };
        }
        return item;
      });
      return updatedViews;
    });
  }

  const confirmRename = () => {
    if (!pendingViewName || pendingViewName === activeView) return;

    const nameWithSuffixIfItAlreadyThere = getUniqueViewNameFromRename(pendingViewName, activeView, localComponentViewsData, componentViews);

    setComponentViewsData(prev =>
      prev.map(view =>
        view.viewName === activeView ? { ...view, viewName: nameWithSuffixIfItAlreadyThere } : view
      )
    );

    setViewsOptions(prev =>
      prev.map(opt =>
        opt.code === activeView ? { code: nameWithSuffixIfItAlreadyThere, description: nameWithSuffixIfItAlreadyThere } : opt
      )
    );

    setActiveView(nameWithSuffixIfItAlreadyThere);
  };

      const handleTextFieldChange = (value: any, name: IRepertoireStateKeys) => {
             setIsFormDirty(true);
                setComponentViewsData(prevState => {
                  const updatedViews = prevState.map(item => {
                      if (item.viewName === activeView) {
                          return {...item, fields: [...item.fields.map(field => field.name === name ? {...field, data: value} : field)]};
                      }
                      return item;
                  });
                  return updatedViews;
              });
          }
      
          const handleToggleChange = (value: boolean, name: IRepertoireStateKeys) => {
              setIsFormDirty(true);
                     setComponentViewsData(prevState => {
                  const updatedViews = prevState.map(item => {
                      if (item.viewName === activeView) {
                          return {...item, fields: [...item.fields.map(field => field.name === name ? {...field, hidden: !value} : field)]};
                      }
                      return item;
                  });
                  return updatedViews;
              });
          }

          const handleCheckBoxChange = (value: boolean, name: IRepertoireStateKeys) => { 
            setIsFormDirty(true);
            setComponentViewsData(prevState => {
                const updatedViews = prevState.map(item => {
                    if (item.viewName === activeView) {
                        return {...item, fields: [...item.fields.map(field => field.name === name ? {...field, isInTheBody: value} : field)]};
                    }
                    return item;
                });
                return updatedViews;
            });
        }

      
  
      let columnsTop: ColumnsType<any> = [
        {
          title: "Field Labels",
          dataIndex: "fieldLabels",
          key: "fieldLabels",
          width: "20%",
          render: (value, record, index) => {
            return      <TextDataInput
                              value={value}
                              fieldName={'fieldLabels'}
                              changeData={(value, stateKey) => { handleTextFieldChange(value as string, record.fieldName)}}
                              readOnly={activeView === DEFAULT_VIEW_NAME}
                              isHidden={false}
                              objectKey={'fieldLabels'}
                                    /> 
          },
        },
        {
          title: "Off / On",
          dataIndex: "isHiddenField",
          key: "isHiddenField",
          width: "15%",
          render: (value, record, index) => {
              const fieldName = record.originalField.name
              const handleChange = (changedValue, stateKey) => {
                  handleToggleChange(record.isHiddenField,  fieldName); 
              }
              return  <ToggleButtonDataInput
                                  changeData={handleChange}
                                  fieldName={`isHiddenField ${record.key}`}
                                  value={value}
                                  label={undefined}
                                  readonly={activeView === DEFAULT_VIEW_NAME}
                              />
          },
          
        },
           {
          title: "Show in Body",
          dataIndex: "isInTheBody",
          key: "isInTheBody",
          width: "65%",
          render: (value, record, index) => {
              const fieldName = record.originalField.name
              const handleChange = (changedValue, stateKey) => {
                  handleCheckBoxChange(changedValue,  fieldName);
              }
              return renderCheckBox(record, fieldName, index, handleChange);
     
          },
        },
        
      ];

      const renderCheckBox = (tableContentItem, objectKey, rowIndex, changeData) => {

              const isModifiable = tableContentItem["isModifiable"] !== false;
                      const currentValue = tableContentItem["isInTheBody"];


         if(!isModifiable){
                          return (
                          <div className="lockContainer">
                                      <LockClosed20Regular className="lockIcon" />
                                      <p className="lockText">Is In The Body</p>
                          </div>
                          );
                      }                
                      return (
                          <div className="tableCell">
                              <CheckboxDataInput
                                  label=""
                                  fieldName={'isInTheBody'}
                                  value={currentValue}
                                  changeData={isModifiable
                                      ? (value, stateKey) => changeData(value, stateKey)
                                      : () => { }}
                                  readonly={!isModifiable}
                                  isHidden={false}
                              />
                          </div>
                      );
            

      }


  
      const buildTableRows = (fields: IRepertoireField[]) => {
        return fields.map((field, index) => ({
          key: `${field.name}_${index}`,
          originalField: field,
          fieldName: field.name,
          fieldLabels: field.data,
          defaultValue: field?.defaultValue || "",
          isHiddenField: field?.hidden,
          isMandatory: field?.isMandatory,
          isModifiable: field?.isMandatoryModifiable !== false,
          isInTheBody: field?.isInTheBody,
        }));
      };
      

  const handleDeleteView = () => {
    setIsFormDirty(true);
    if (!activeView) return;

    if (activeView === DEFAULT_VIEW_NAME) {
      return;
    }


    const newUpdatedViews = localComponentViewsData.map((view, index) => {
      if (view.viewName === activeView && view.viewName !== DEFAULT_VIEW_NAME) {
        view.isDeleted = true;
      }
      return view;
    });

    const fallbackView = newUpdatedViews.length > 0 ? newUpdatedViews[0].viewName : DEFAULT_VIEW_NAME;

    setComponentViewsData(newUpdatedViews);
    getViewsOptions(newUpdatedViews)
    setActiveView(fallbackView);
    setPendingViewName(fallbackView);

    const fallbackFields = newUpdatedViews.find(v => v.viewName === fallbackView)?.fields || [];
    setTableContents(fallbackFields);
  };

  const handleAddNewView = () => {
    if (!localComponentViewsData || localComponentViewsData.length === 0) return;
    const newView: IComponentView = createNewView(getUniqueViewName(localComponentViewsData), DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY, tableContents.map(field => ({ ...field, isMandatoryModifiable: true })));
    setComponentViewsData(prev => [...prev, newView]);
    setViewsOptions(prev => [...prev, { code: newView.viewName, description: newView.viewName }]);
    setActiveView(newView.viewName);
    setPendingViewName(newView.viewName);
    setTableContents(newView.fields);
  }
  const renderDataGridTable = () => {
    return (
      <div>
        <div className="flexRow paddingLeftLarge">
          <SizedTextDataInput
            label={componentViewData?.fields?.find(item => item.name === RENAME_SELECTED_VIEW)?.data ? componentViewData?.fields?.find(item => item.name === RENAME_SELECTED_VIEW)?.data : 'Rename selected view'}
            isHidden={false}
            changeData={handleViewNameDataChange}
            fieldName="usageDescription"
            onBlurEvent={confirmRename}
            isOnBlurOn={true}
            value={pendingViewName}
            readOnly={activeView === DEFAULT_VIEW_NAME}
            handleKeyDown={(e) => e.key === 'Enter' && confirmRename()}
          />
          <SizedDropdownDataInput
            options={viewsOptions}
            label={componentViewData.fields.find(item => item.name === SELECT_VIEW_TO_CONFIGURE)?.data || 'Select View to Configure'}
            changeData={handleViewDropdownDataChange}
            value={activeView ? activeView : DEFAULT_VIEW_NAME}
            fieldName={SELECT_VIEW_TO_CONFIGURE}
            componentInstance={componentInstance}
            isHidden={false}
            isMandatory={false}
            backendSearch={false}
            allowNull={false}
            allowFreeInput={false}
          />
          <div className="flexRow paddingRightLarge">
            <IconTextButton
              disabled={activeView === DEFAULT_VIEW_NAME}
              onClick={handleDeleteView}
              text={'Delete'}
              icon={Delete20Regular}
            />
          </div>
          <IconTextButton
            disabled={false}
            onClick={handleAddNewView}
            text={'Add'}
            icon={AddCircle20Regular}
          />

        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p>{viewData[USAGE_DESCRIPTION_EDITABLE_VIEW]}</p>
        </div>
                  <div style={{ width: "100%", overflow: "clip" }}>
                                        <Table
                                            style={{ width: "100%" }}
                                            tableLayout="fixed"
                                            rowKey={(record) => record.key}
                                            columns={columnsTop}
                                            dataSource={buildTableRows(activeView === DEFAULT_VIEW_NAME ? tableContents : tableContent)}                                                            
                                            rowClassName={() => 'editable-row'}
                                            size={'small'}
                                            onChange={() => { } }
                                            className="parent-table"
                                            pagination={false}
                                        />
                                        </div>


        {renderActionButtons()}
      </div>
    );
  }


  if (loaded) {
    return (
      <>

        {renderDataGridTable()}
      </>
    );
  }
  else {
    return <div>Loading...</div>
  }

};

export default UsageMaintenanceDetailTableFieldSettingView;
